const es = {
  "hotel.service.operation_center": "Centro de Operaciones",
  "hotel.service.environment": "Entorno",
  "hotel.service.service_date": "Fecha",
  "hotel.service.kind": "Servicio",
  "hotel.service": "Servicio Alimentación",
  "hotel.service.line": "Servicio Alimentación",
  "hotel.service.line.service": "Servicio",
  "hotel.service.line.room": "Habitación",
  "hotel.service.line.time_service": "Fecha de Servicio",
  "hotel.service.line.product": "Producto",
  "hotel.service.line.quantity": "Cantidad",
  "hotel.service.line.description": "Descripción",
  "hotel.service.line.order": "Orden",
  "hotel.service.line.guest": "Huesped",
  "hotel.service.line.charge_button": "Cargar",
  "hotel.service.line.stock_move": "Movimiento de Stock",
  "hotel.service.line.analytic_account": "Cuenta Analítica",
  "hotel.service.line.unit_price_w_tax": "Precio Unitario con Impuestos",
  "hotel.service.line.storage": "Almacenamiento",
  "hotel.service.lines": "Líneas de Servicio",
  "hotel.service.number": "Número de Servicio",
  "hotel.service.notes": "Notas",
  "hotel.service.storage": "Almacenamiento",
  "hotel.service.count_services": "Contar Servicios",
  "hotel.service.company": "Empresa",
  "hotel.service.line.unit_price": "Precio Unitario",
  "hotel.service.line.state": "Estado",
  "hotel.service.line.folio": "Folio",
  "hotel.service.state": "Estado",
  "menu.service_hotel": "Servicios",
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  "hotel.service.line.draft": "Pendiente",
  "hotel.service.line.loaded": "Cargado",
  "hotel.service.total": "Total",
  "hotel.service.draft": "Pendiente",
};
export default es;
